// Göreli zaman etiketi ("2 saat önce", "dün", "geçen hafta") — bildirim satırı için.
//
// Native `Intl.RelativeTimeFormat('tr')` kullanır: yeni bağımlılık yok, Türkçe
// çıktı yerel (numeric:'auto' → "dün"/"geçen ay" gibi doğal ifadeler). dayjs
// global locale'ini değiştirmemek için ayrı, saf yardımcı.

const rtf = new Intl.RelativeTimeFormat('tr', { numeric: 'auto' });

const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ['year', 31_536_000],
  ['month', 2_592_000],
  ['week', 604_800],
  ['day', 86_400],
  ['hour', 3_600],
  ['minute', 60],
];

/**
 * ISO zaman damgasını Türkçe göreli etikete çevirir. Geçersiz girdi → boş string.
 * `now` enjekte edilebilir (deterministik test için).
 */
export function relativeTimeTr(iso: string, now: Date = new Date()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const diffMs = then - now.getTime(); // geçmiş için negatif
  const diffSec = diffMs / 1000;
  const absSec = Math.abs(diffSec);
  if (absSec < 45) return 'az önce';
  for (const [unit, secs] of UNITS) {
    if (absSec >= secs) {
      return rtf.format(Math.round(diffSec / secs), unit);
    }
  }
  return rtf.format(Math.round(diffSec / 60), 'minute');
}
